import importRetry from "../importRetry.js";
import Logging from "../Logging.js";
import processingStore from "./processingStore.js";
import StateStoreBase from "./StateStoreBase.js";
var ELanguage = /* @__PURE__ */ ((ELanguage2) => {
  ELanguage2["Unknown"] = "Unknown";
  ELanguage2["French"] = "French";
  ELanguage2["English"] = "English";
  ELanguage2["Spanish"] = "Spanish";
  ELanguage2["Portuguese"] = "Portuguese";
  return ELanguage2;
})(ELanguage || {});
const localeStorageKey = {
  key: "Locale",
  pathIndependant: true,
  userIndependant: true
};
const languages = [
  {
    apiId: "English",
    databaseId: 2,
    dateFns: void 0,
    localeId: "en-ca",
    materialUI: void 0,
    name: "English",
    twoLetterCode: "en"
  },
  {
    apiId: "French",
    databaseId: 1,
    dateFns: void 0,
    localeId: "fr-ca",
    materialUI: void 0,
    name: "Français",
    twoLetterCode: "fr"
  }
];
class LanguageStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.currentLanguage = languages[0];
  }
  get() {
    return this.currentLanguage;
  }
  getAll() {
    return languages;
  }
  async set(localeOrCode) {
    const localeOrCodeLower = localeOrCode.toLowerCase();
    let language = languages.find(
      (l) => l.localeId === localeOrCodeLower || l.twoLetterCode === localeOrCodeLower
    );
    if (!language) {
      void Logging.warning(
        `Unknown language locale or code ${localeOrCodeLower}`
      );
      language = languages.find((l) => l.twoLetterCode === "fr");
    }
    await this.updateLanguage(language);
  }
  async setById(languageId) {
    let language = languages.find((l) => l.databaseId === languageId);
    if (!language) {
      if (typeof window.console !== "undefined") {
        console.warn(`Unknown languageId ${languageId.toString()}`);
      }
      language = languages.find((l) => l.twoLetterCode === "fr");
    }
    await this.updateLanguage(language);
  }
  async updateLanguage(language) {
    processingStore.processingStarted();
    try {
      let localesModule = void 0;
      switch (language.twoLetterCode) {
        case "en":
          localesModule = await importRetry(
            () => import("./locales/enLibraryLocales.js")
          );
          break;
        case "fr":
          localesModule = await importRetry(
            () => import("./locales/frLibraryLocales.js")
          );
          break;
        default:
          void Logging.error(`Unknown language ${language.twoLetterCode}`);
      }
      this.currentLanguage = {
        ...language,
        ...localesModule == null ? void 0 : localesModule.default
      };
      this.notifySubscribers();
    } catch (ex) {
      void Logging.warning(ex);
    } finally {
      processingStore.processingStopped();
    }
  }
}
const languageStore = new LanguageStore();
export {
  ELanguage,
  LanguageStore,
  languageStore as default,
  localeStorageKey
};
//# sourceMappingURL=languageStore.js.map
